export const calculateDimensions = (length: number, max = 130, min = 105) =>
  max * length > min ? max * length : min;

export const calculateMargin = (max = 50) => max * Math.random();
